import { ImageProps } from 'next/image'
import React, { ReactNode } from 'react'

import {
  Avatar as MuiAvatar,
  AvatarProps as MuiAvatarProps
} from '@mui/material'

import AvatarIcon from 'app/assets/icons/user-avatar.svg'

import Image from '../Image'
import Skeleton from '../Skeleton'

interface AvatarProps extends Omit<MuiAvatarProps, 'src' | 'width' | 'height'> {
  src?: ImageProps['src']
  imageUri?: string
  width?: number
  height?: number
  sizes?: ImageProps['sizes']
  placeholder?: string
  loading?: boolean
  icon?: ReactNode
}

const Avatar = ({
  src,
  imageUri,
  width = 64,
  height = 64,
  sizes,
  sx = {},
  loading,
  icon,
  children
}: AvatarProps) => {
  const curSrc = imageUri || src
  const currentIcon = icon || <AvatarIcon />

  if (loading) {
    return (
      <Skeleton
        variant="circular"
        sx={{
          // @ts-ignore - todo: fix
          width,
          // @ts-ignore - todo: fix
          height,
          ...sx
        }}
      />
    )
  }

  return (
    <MuiAvatar
      sx={{
        textTransform: 'uppercase',
        bgcolor: curSrc ? 'none' : 'primary.main',
        width,
        height,
        ...sx,
        display: curSrc ? 'block' : 'flex'
      }}
    >
      {!curSrc && !children && currentIcon}

      {curSrc ? (
        <Image
          fill
          objectFit="cover"
          objectPosition="center"
          src={curSrc}
          width={width}
          height={height}
          sizes={sizes}
          alt="avatar"
        />
      ) : (
        children
      )}
    </MuiAvatar>
  )
}

export default Avatar
